window.addEventListener("load", function () {
    

    new Swiper(".swiper-diemdanh", {
        slidesPerView: 4,
        spaceBetween: 0,
        navigation: {
            prevEl: ".bg-board .swiper-button-prev",
            nextEl: ".bg-board .swiper-button-next",
        },
        breakpoints: {
            0: {
                slidesPerView: 3,
            },
            769: {
                slidesPerView: 4,
            },
        },
    });

    

});